import { secureStorage } from './utilities-secure-storage';

export default class userSessionStorage {
  getUserInfo2() {
    if (window){
      return secureStorage.getItem("DATA") !== null
        ? { ...JSON.parse(secureStorage.getItem("DATA")) }
        : null
    }
    else{
      return null
    }
  }

  getUserInfo() {
    return secureStorage.getItem("DATA") !== null
      ? { ...JSON.parse(secureStorage.getItem("DATA")) }
      : null
  }

  getToken() {
    return localStorage.getItem("TOKEN_INFO") !== null
      ? { ...JSON.parse(localStorage.getItem("TOKEN_INFO")) }
      : null
  }

  destroySession() {
    secureStorage.removeItem("DATA");
  }

  getNoPrefix(num) {
    return num.slice(process.env.COUNTRY_PHONE_PREFIX.length, num.length)
  }
}
